import axios from "../axios";

export const getCourses = async (params) => {
  return await axios.get(`/api/courses`, {
    params
  });
};
